class CommonUtils {
  goToNext = (url: string): void => {
    console.log(url);
    window.location.href = url;
  };

  getNumberOnly = (value: string): string => {    
    return value.replace(/[^0-9]/g, '');
  };

  checkEmail = (value:string): boolean => {
    const emailRegEx = /^[A-Za-z0-9]([-_.]?[A-Za-z0-9])*@[A-Za-z0-9]([-_.]?[A-Za-z0-9])*\.[A-Za-z]{2,3}$/i;
  
    return emailRegEx.test(value); //형식에 맞을 경우, true 리턴
  }
  
}

export default new CommonUtils();